(() => {
  if (window.__cwsQuickAdd) return;
  window.__cwsQuickAdd = true;

  const root = window.Shopify?.routes?.root || '/';
  const getBtn = (e) => e.target.closest?.('.cws-cart-icon-btn');

  ['pointerdown', 'mousedown', 'touchstart'].forEach((evt) =>
    document.addEventListener(evt, (e) => { if (getBtn(e)) e.stopPropagation(); }, true)
  );

  document.addEventListener('click', async (e) => {
    const btn = getBtn(e);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    console.log('CWS Quick Add click, variante:', variantId);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        console.error('CWS Quick Add error:', data.description || data.message);
        return;
      }

      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = {
        resource: cart,
        sourceId: `cws-quick-add-${variantId}`,
        data: { source: 'cws-quick-add', itemCount: cart.item_count },
      };
      document.dispatchEvent(ev);

      btn.style.transform = 'scale(1.2)';
      setTimeout(() => (btn.style.transform = ''), 200);
    } catch (err) {
      console.error('CWS Quick Add fetch error:', err);
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }, true);
})();